/* FITPEAK LAB ／ 総負荷量計算（sections/lab-volume.liquid）
   総負荷量 = 重量 × 回数 × セット数（Souhukaアプリと同じ式）。
   前回の記録はこの端末の localStorage にだけ残す（サーバーへは送らない）。
   テスト: node --test scripts/test/lab-volume.test.cjs */
(function () {
  'use strict';

  var KEY = 'fp_lab_volume_v1';
  var MAX = 30;
  var EQ = [
    { label: 'アフリカゾウ', unit: '頭', kg: 6000 },
    { label: '軽自動車', unit: '台', kg: 900 },
    { label: '冷蔵庫', unit: '台', kg: 80 }
  ];

  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }

  function total(rows) {
    var items = [], sum = 0, sets = 0, reps = 0;
    rows.forEach(function (r, i) {
      var w = num(r.weight), rp = Math.round(num(r.reps)), s = Math.round(num(r.sets));
      if (w <= 0 || rp <= 0 || s <= 0) return;
      var name = String(r.name || '').trim() || '種目' + (i + 1);
      var v = Math.round(w * rp * s * 10) / 10;
      items.push({ name: name, weight: w, reps: rp, sets: s, volume: v });
      sum += v; sets += s; reps += rp * s;
    });
    return { items: items, total: Math.round(sum * 10) / 10, sets: sets, reps: reps };
  }

  function compare(now, prev) {
    if (!prev || !(prev > 0)) return null;
    var diff = Math.round((now - prev) * 10) / 10;
    return { diff: diff, pct: Math.round(diff / prev * 1000) / 10 };
  }

  function equivalent(kg) {
    for (var i = 0; i < EQ.length; i++) {
      var c = Math.floor(kg / EQ[i].kg);
      if (c >= 1) return { label: EQ[i].label, unit: EQ[i].unit, count: c };
    }
    return null;
  }

  function read(store) {
    try {
      var a = JSON.parse(store.getItem(KEY) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) { return null; }
  }

  function remember(store, session) {
    try {
      var a = read(store) || [];
      a.unshift(session);
      store.setItem(KEY, JSON.stringify(a.slice(0, MAX)));
    } catch (e) { /* 保存できない環境（プライベートブラウズ等）では前回比を出さないだけ */ }
  }

  function previous(store, names) {
    var a = read(store);
    if (!a || !a.length) return null;
    var byName = {};
    names.forEach(function (n) {
      for (var i = 0; i < a.length; i++) {
        var hit = (a[i].items || []).filter(function (it) { return it.name === n; })[0];
        if (hit) { byName[n] = hit.volume; break; }
      }
    });
    return { date: a[0].date, total: a[0].total, byName: byName };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { total: total, compare: compare, equivalent: equivalent, remember: remember, previous: previous };
  if (typeof document === 'undefined') return;

  /* ── 画面 ── */
  var root = document.getElementById('lab-vol');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = null;
  try { store = window.localStorage; } catch (e) { store = null; }
  function $(id) { return document.getElementById(id); }
  function fmt(n) { return (Math.round(n * 10) / 10).toLocaleString('ja-JP'); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sign(c) { return c.diff > 0 ? '+' : ''; }

  var list = $('lab-vol-rows'), tpl = $('lab-vol-row');
  function addRow(focus) {
    var n = list.children.length + 1;
    var row = tpl.content.firstElementChild.cloneNode(true);
    row.querySelector('.lab-vol-no').textContent = n;
    list.appendChild(row);
    renumber();
    if (focus) row.querySelector('input').focus();
  }
  function renumber() {
    Array.prototype.forEach.call(list.children, function (r, i) {
      r.querySelector('.lab-vol-no').textContent = i + 1;
      r.querySelector('.lab-vol-x').hidden = list.children.length < 2;
    });
  }
  list.addEventListener('click', function (e) {
    var x = e.target.closest('.lab-vol-x'); if (!x) return;
    x.closest('.lab-vol-row').remove(); renumber();
  });
  $('lab-vol-add').addEventListener('click', function () { addRow(true); });
  addRow(false);

  function rows() {
    return Array.prototype.map.call(list.children, function (r) {
      var q = function (k) { return r.querySelector('[data-k="' + k + '"]').value; };
      return { name: q('name'), weight: q('weight'), reps: q('reps'), sets: q('sets') };
    });
  }

  var go = $('lab-vol-go');
  $('lab-vol-form').addEventListener('submit', function (e) {
    e.preventDefault(); if (go.classList.contains('is-busy')) return;
    var r = total(rows());
    var err = $('lab-vol-err');
    if (!r.items.length) { err.hidden = false; list.querySelector('[data-k="weight"]').focus(); return; }
    err.hidden = true;
    var prev = store ? previous(store, r.items.map(function (i) { return i.name; })) : null;
    go.classList.add('is-busy');
    go.innerHTML = '<span class="lab-spin"></span>計算中…<span class="lab-prog"><b></b></span>';
    setTimeout(function () {
      go.classList.remove('is-busy'); go.textContent = '計算する';
      show(r, prev);
      if (store) remember(store, { date: new Date().toISOString().slice(0, 10), total: r.total, items: r.items.map(function (i) { return { name: i.name, volume: i.volume }; }) });
      var res = $('lab-vol-res'); res.hidden = false;
      res.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, reduce ? 0 : 700);
  });

  function show(r, prev) {
    $('lab-vol-n').textContent = fmt(r.total);
    $('lab-vol-sub').innerHTML = '<b>' + r.items.length + '種目・' + r.sets + 'セット・合計' + r.reps + '回</b> の総負荷量';
    var c = prev ? compare(r.total, prev.total) : null;
    $('lab-vol-cmp').textContent = c ? sign(c) + fmt(c.diff) + 'kg' : '–';
    $('lab-vol-cmps').textContent = c ? '前回（' + prev.date + '）比 ' + sign(c) + c.pct + '%' : '次回から、この端末で前回と比べられます';
    $('lab-vol-avg').textContent = fmt(r.total / r.sets) + 'kg';
    var q = equivalent(r.total);
    $('lab-vol-eq').textContent = q ? q.label + q.count + q.unit + '分' : '–';
    $('lab-vol-eqs').textContent = q ? '持ち上げた重さの合計をたとえると' : '';

    var max = r.items.reduce(function (m, i) { return Math.max(m, i.volume); }, 0);
    $('lab-vol-tbody').innerHTML = r.items.map(function (i) {
      var pc = prev && prev.byName[i.name] ? compare(i.volume, prev.byName[i.name]) : null;
      return '<tr><td>' + esc(i.name) + '<small>' + fmt(i.weight) + 'kg × ' + i.reps + '回 × ' + i.sets + 'セット</small>' +
        '<span class="lab-vol-bar" style="width:' + Math.max(4, i.volume / max * 100).toFixed(1) + '%"></span></td>' +
        '<td>' + fmt(i.volume) + 'kg</td>' +
        '<td class="' + (pc ? (pc.diff >= 0 ? 'up' : 'dn') : '') + '">' + (pc ? sign(pc) + pc.pct + '%' : '–') + '</td></tr>';
    }).join('');

    var gk = $('lab-vol-gk'), gt = $('lab-vol-gt');
    if (c && c.diff > 0) { gk.textContent = '+' + c.pct + '%'; gt.innerHTML = '前回より<b>' + fmt(c.diff) + 'kg</b>多く挙げています。この調子で、重量か回数を少しずつ増やしていきましょう。'; }
    else if (c) { gk.textContent = c.pct + '%'; gt.innerHTML = '前回より少なめです。疲れている日は無理をせず、次回<b>' + fmt(prev.total) + 'kg</b>超えを目標にしましょう。'; }
    else { var t = Math.round(r.total * 1.05 / 10) * 10; gk.textContent = fmt(t) + 'kg'; gt.innerHTML = '次回の目標は<b>5%増しの' + fmt(t) + 'kg</b>。1セットだけ回数を1回増やすところから始めましょう。'; }
  }
})();
